import { FormattedMessage } from 'react-intl';
import Link from '@alltrails/denali/components/Link';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import FunFact from '../FunFact';
import styles from './PeakFeatureList.module.scss';
import PeakFeatureListTable from './PeakFeatureListTable';

type Props = {
  tierSelected: PurchaseTier;
  upsellTrigger: UpsellTrigger;
  hasHeaderScrollMargin?: boolean;
  hidePeak?: boolean;
};

// Design File https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=5541-181584&m=dev
export default function PeakFeatureList({ upsellTrigger, tierSelected = 'peak', hasHeaderScrollMargin, hidePeak }: Props) {
  return (
    <>
      <PeakFeatureListTable
        tierSelected={tierSelected}
        upsellTrigger={upsellTrigger}
        hasHeaderScrollMargin={hasHeaderScrollMargin}
        hidePeak={hidePeak}
      />
      <FunFact upsellTrigger={upsellTrigger} />
      <div className={styles.linksContainer}>
        <Link href="/privacy" className={styles.link} target="_blank" variant="secondary">
          <FormattedMessage defaultMessage="Privacy Policy" />
        </Link>
        <div className={styles.divider} />
        <Link href="/terms" className={styles.link} target="_blank">
          <FormattedMessage defaultMessage="Terms of Service" />
        </Link>
      </div>
    </>
  );
}
